<div (copy)="blockCopy()" (cut)="blockCut()" appBlockPrint class="no-print">
  <h1 class="page-title">
    Credential Maintenance Assessment Dashboard
<!--     <a href="https://www.nbrc.org/cmp-assessment-instructions/" target="_blank" class="icon-link page-title__icon-link" aria-label="Help">
        <span class="icon-link__icon">?</span>
    </a>
 -->  
  </h1>
  <div class="assessment-activation" *ngIf="cyd && cyd.credentials && cyd.credentials.length === 0">
     <p>
      Your credentials are expired and you are no longer eligible to take assessments. Go to Enter my CEUs and read about how to reinstate your credentials.
     </p>
  </div>
  <div class="assessment-activation" *ngIf="(cyd && cyd.credentials && cyd.credentials.length>0) && subjectToCMP && !(status === 'A' || status === 'E') && !isUnderNBRCJE">
    <strong><p style="color: red">You have not paid the annual CMP fee. Please consider <a routerLink="/purchase/annual-renewal">paying</a> now.</p></strong>
  </div>
  <div class="assessment-activation" *ngIf="(cyd && cyd.credentials && cyd.credentials.length>0) && !subjectToCMP && !(status === 'S' || status === 'A') && !isUnderNBRCJE">
    <strong><p style="color: red">You must pay the annual support fee to participate in the Credential Maintenance Program (CMP) and activate assessments. Please consider <a routerLink="/purchase/annual-renewal">paying</a> now.</p></strong>
  </div>
  <div *ngIf="!subjectToCMP && !(status === 'S' || status === 'A') && isUnderNBRCJE">
    <strong><p style="color: red">You are not eligible to participate in the CMP assessments. Contact the NBRC Executive Office at 913.895.4900 or je@nbrc.org for more information.</p></strong>
  </div>
  <div class="assessment-activation" *ngIf="(cyd && cyd.credentials && cyd.credentials.length>0) && cyd.allowOptIn && !isUnderNBRCJE">
    <p>You are not required to participate in the CMP for credentials earned before July 1, 2002. You may choose to
      participate with no consequence of your lifetime credential(s) expiring. If this is your choice, click "Activate
      Assessment." Log in to the Credential Practitioner Portal at any time to de-activate assessments.</p>
    <button type="button" class="button" (click)="activateAssessment()" [disabled]="!(status==='S' || status==='A')">Activate Assessment</button>
  </div>
  <div class="col-wrap" *ngIf="subjectToCMP || (!subjectToCMP && (status ==='A' || status==='S'))">
    <div class="col col--secondary col--right" *ngIf="cyd.asOfDate">
      <section class="total-ceus-due">
        <app-graph [cyd]="cyd" [credential]="credential"></app-graph>
      </section>
    </div>
    <div class="col col--primary col--separator col--left" *ngIf="cyd && cyd.credentials && credentials.length > 0">
      <div class="item-list">
        <p *ngIf="credentials.length > 1">To display  available assessments, please select a credential type.</p>
        <h4 *ngIf="credentials.length > 1">Credential type</h4>
        <form>
          <fieldset class="field-group field-group--inline ">
            <ul class="field-list field-list--inline field-list--inline-wrap">
              <li class="field field--inline field-list__item  field-list__item--inline" *ngFor="let credential of credentials">
                <input class="input input--radio" id="credential-{{credential.name}}" name="credential" type="radio"
                  [(ngModel)]="selectedCredential" (ngModelChange)="selectCredential($event)" [value]="credential.name"
                  [checked]="credential.name === credentials[0].name">
                <label for="credential-{{credential.name}}" class="label label--inline">{{credential.name}}</label>
              </li>
            </ul>
          </fieldset>
        </form>        
        <header class="item-list__header">
          <h2 class="item-list__title">Performance by Assessment</h2>
        </header>    
        <div *ngIf="credential && !credential.name">
          <p><strong>You must select a credential type to view available assessments.</strong></p>
        </div>    
        <div class="item-list__items" *ngIf="!cyd.showDashBoard && credential && credential.name">
          <p>You have completed all available assessments.</p>
        </div>
        <div class="item-list__items" *ngIf="cyd.showDashBoard && !cyd.availableNewAssessments">
          <p>You have completed all available assessments.</p>
        </div>
        <div class="item-list__items" *ngIf="credential">
          <ng-template ngFor let-assessment [ngForOf]="credential.assessments">
            <div class="item assessment-summary">
              <div class=" assessment-summary__text" *ngIf="assessment.isPublished && assessment.isCompleted ; else closed">
                <h3>{{assessment.assessmentTitle}}</h3>
                <div>{{assessment.questionsCorrectCount}} Correct, {{assessment.questionsAnsweredCount - assessment.questionsCorrectCount}} Incorrect, {{assessment.questionsUnAnsweredCount}} Unanswered; 
                  Close<span *ngIf="assessment.isClosed">d</span><span *ngIf="!assessment.isClosed">s</span> on
                  <time datetime="assessment.closesOn">{{assessment.closesOn | amDateFormat: 'MM/DD/YYYY'}}</time></div>
                <div *ngIf="assessment.currentCycle" class="crceOnly">{{crceOnlyText}}</div>
              </div>
              <div class="button-list assessment-summary__button-list" *ngIf="assessment.isPublished && assessment.isCompleted && (isAvailable(assessment)||canReview(assessment)) && !isCredentialExpired()">
                <button type="button" class="button button--secondary button--small button-list__item" (click)="reviewResult(assessment)">Review</button>
              </div>
              <ng-template #closed>
                <div class="assessment-summary__text" *ngIf="isExpired(assessment); else start">
                  <h3>{{assessment.assessmentTitle}}</h3>
                  <div>{{assessment.questionsCorrectCount}} Correct, {{assessment.questionsAnsweredCount - assessment.questionsCorrectCount}} Incorrect, {{assessment.questionsUnAnsweredCount}} Unanswered; 
                    Close<span *ngIf="assessment.isClosed">d</span><span *ngIf="!assessment.isClosed">s</span> on
                    <time datetime="assessment.closesOn">{{assessment.closesOn | amDateFormat: 'MM/DD/YYYY'}}</time></div>
                    <div *ngIf="assessment.currentCycle" class="crceOnly">{{crceOnlyText}}</div>
                  </div>
                <div class="button-list assessment-summary__button-list" *ngIf="assessment.isPublished && canReview(assessment) && !isCredentialExpired()">
                  <button type="button" class="button button--secondary button--small button-list__item" (click)="reviewResult(assessment)">Review</button>
                </div>
              </ng-template>             
              <ng-template #start>
                <div class="assessment-summary__text" *ngIf="assessment.isPublished && assessment.questionsAnsweredCount === 0 && isAvailable(assessment) ; else resume">
                  <h3>{{assessment.assessmentTitle}}</h3>
                  <div><span style="color: green"> Assessment Open</span>; Closes on <time datetime="assessment.closesOn">{{assessment.closesOn
                      | amDateFormat: 'MM/DD/YYYY' || '-'}}</time></div>
                  <div *ngIf="assessment.currentCycle" class="crceOnly">{{crceOnlyText}}</div>
                </div>
                <div class="button-list assessment-summary__button-list" *ngIf="assessment.isPublished && assessment.questionsAnsweredCount === 0  && isAvailable(assessment) && !isCredentialExpired() ">
                  <button type="button" class="button button--alt button--small button-list__item" (click)="startAssessment(assessment)">Start</button>
                </div>
                <div class="button-list assessment-summary__button-list" *ngIf="assessment.isPublished && assessment.questionsAnsweredCount === 0 && canReview(assessment) && !isCredentialExpired()">
                  <button type="button" class="button button--secondary button--small button-list__item" (click)="reviewResult(assessment)">Review</button>
                </div>
              </ng-template>
              <ng-template #resume>
                <div class="assessment-summary__text" *ngIf="assessment.isPublished && assessment.questionsAnsweredCount >0 && !assessment.isCompleted && isAvailable(assessment); else willAvailable">
                  <h3>{{assessment.assessmentTitle}}</h3>
                  <div><span style="color: green"> Assessment Open</span>; Closes on
                    <time datetime="assessment.closesOn">{{assessment.closesOn | amDateFormat: 'MM/DD/YYYY' || '-'}}</time></div>
                    <div *ngIf="assessment.currentCycle" class="crceOnly">{{crceOnlyText}}</div>
                </div>
                <div class="button-list assessment-summary__button-list" *ngIf="assessment.questionsAnsweredCount > 0 && !assessment.isCompleted && isAvailable(assessment) && !isCredentialExpired()">
                  <button type="button" class="button button--secondary button--small button-list__item" (click)="reviewResult(assessment)">Review</button>
                  <button type="button" class="button button--alt button--small button-list__item" (click)="startAssessment(assessment)">Continue</button>
                </div>
              </ng-template>
              <ng-template #willAvailable>
                <div class="assessment-summary__text" *ngIf="!assessment.assessmentResultId && willBeAvailable(assessment)">
                  <h3>{{assessment.assessmentTitle}}</h3>
                  <div>{{assessment.questionsTotalCount}} Questions; Opens on <time datetime="assessment.opensOn">{{assessment.opensOn
                      | amDateFormat: 'MM/DD/YYYY' || '-'}}</time></div>
                  <div *ngIf="assessment.currentCycle" class="crceOnly">{{crceOnlyText}}</div>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>